import { render, staticRenderFns } from "./ContractorAcceptForm.vue?vue&type=template&id=5f20afeb&"
import script from "./ContractorAcceptForm.vue?vue&type=script&lang=js&"
export * from "./ContractorAcceptForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports